import React from "react"
import { Button, Glyphicon } from "react-bootstrap"

/**
 * Note: idk why this doesn't work with credentials: same origin
 * i need to use the "api key"
 */

const update = (withKey) => {
  fetch(
    withKey ? "/updatecontent/naslkn1onl9oap1gjqx" : "/updatecontent",
    {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      credentials: "same-origin",
    }
  )
    .then(res => {
      alert(`${res.status}: ${res.statusText}`)
      console.log(res)
    })
    .catch(() => alert("ERROR?"))
}

const UpdateContentPage = () => (
  <div style={{padding: 20}}>
    <Button onClick={update.bind(null, true)}><Glyphicon glyph="refresh" /> Actualizar</Button>
  </div>
)

export default UpdateContentPage



// WEBPACK FOOTER //
// ./src/app/admin/components/UpdateContentPage.jsx